import { ChatBlkAppContext } from '../types';
import {
    ChatBlkBaseService,
    ChatBlkQueryService,
    ChatBlkTelemetryService,
    PostTelemetryEventsOverride,
} from '.';

interface ChatBlkServices {
    baseInstance: ChatBlkBaseService;
    chatBlkQueryServiceInstance: ChatBlkQueryService;
    chatBlkTelemetryServiceInstance: ChatBlkTelemetryService;
}

/**
 * Factory class for initializing and retrieving instances of ChatBlk services.
 */
export class ChatBlkServiceFactory {
    private static services: ChatBlkServices;
    private static baseInstance: ChatBlkBaseService;
    private static chatBlkQueryServiceInstance: ChatBlkQueryService;
    private static chatBlkTelemetryServiceInstance: ChatBlkTelemetryService;

    /**
     * Initializes the ChatBlk services.
     *
     * @param chatBlkAppContext - Optional context for the ChatBlk application.
     * @param isChatBlkEmbedded - Flag indicating if ChatBlk is embedded.
     * @param postTelemetryEventsOverride - Optional override for telemetry events.
     * @returns An object containing instances of the ChatBlk services.
     */
    public static initServices(
        chatBlkAppContext?: ChatBlkAppContext,
        isChatBlkEmbedded = false,
        postTelemetryEventsOverride: PostTelemetryEventsOverride = null
    ): ChatBlkServices {
        if (chatBlkAppContext && !ChatBlkBaseService.getInstance()) {
            ChatBlkServiceFactory.baseInstance = ChatBlkBaseService.getInstance(
                chatBlkAppContext,
                isChatBlkEmbedded,
                postTelemetryEventsOverride
            );
        }
        ChatBlkServiceFactory.chatBlkQueryServiceInstance =
            ChatBlkQueryService.getInstance();
        ChatBlkServiceFactory.chatBlkTelemetryServiceInstance =
            ChatBlkTelemetryService.getInstance();
        ChatBlkServiceFactory.services = {
            baseInstance: ChatBlkServiceFactory.baseInstance,
            chatBlkQueryServiceInstance:
                ChatBlkServiceFactory.chatBlkQueryServiceInstance,
            chatBlkTelemetryServiceInstance:
                ChatBlkServiceFactory.chatBlkTelemetryServiceInstance,
        };
        return this.services;
    }

    public static getServices() {
        return ChatBlkServiceFactory.services;
    }
}
